import { useEffect } from 'react'
import Cookies from 'js-cookie'
import {
    useAuthInfo,
    useLogoutFunction,
    useRedirectFunctions,
} from '@propelauth/react'
import { isCustomerUser } from 'utils/user.utils'
import { TOKEN_KEY, TOKEN_REFRESH_KEY } from 'constants/app.constants'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { isSuperAdmin } from 'utils/user.utils'
import { URLS } from 'utils/url.utils'
import { useAuthLogin } from 'mutations/user.mutations'
import Column from 'components/core/Column'
import { CircularProgress } from '@mui/material'
import { DESIGN_TOKENS } from 'constants/color.constants'

export const AuthLogin = () => {
    const {
        loading: isLoadingAuthInfo,
        isLoggedIn,
        accessToken,
    } = useAuthInfo()
    const logout = useLogoutFunction()
    const { redirectToLoginPage } = useRedirectFunctions()
    const navigate = useNavigate()
    const { mutateAsync: authLogin } = useAuthLogin()
    const [searchParams] = useSearchParams()
    const redirectTo = searchParams.get('redirectTo')
    const orgId = searchParams.get('orgId')

    useEffect(() => {
        const login = async () => {
            if (isLoadingAuthInfo) {
                return
            }

            if (!isLoggedIn || !accessToken) {
                redirectToLoginPage()
                return
            }

            try {
                const { data } = await authLogin({
                    orgId,
                    accessToken,
                })
                const { user, token, refreshToken } = data

                Cookies.set(TOKEN_KEY, token, {
                    expires: 1,
                    secure: true,
                    sameSite: 'Strict',
                })
                Cookies.set(TOKEN_REFRESH_KEY, refreshToken, {
                    expires: 30,
                    secure: true,
                    sameSite: 'Strict',
                })

                if (redirectTo) {
                    navigate(redirectTo)
                    return
                } else if (isSuperAdmin(user)) {
                    navigate(URLS.cartage.superAdmin.home())
                    return
                } else if (isCustomerUser(user)) {
                    navigate(URLS.cartage.shipperPortal.home())
                    return
                }

                navigate(URLS.cartage.home())
            } catch (error) {
                logout(false)
                redirectToLoginPage()
            }
        }

        login()
    }, [
        logout,
        redirectToLoginPage,
        isLoadingAuthInfo,
        isLoggedIn,
        navigate,
        authLogin,
        accessToken,
        redirectTo,
        orgId,
    ])

    return (
        <Column
            fullHeight
            fullWidth
            justifyContent="center"
            alignItems="center"
        >
            <CircularProgress
                style={{ color: DESIGN_TOKENS.text.mutedForeground }}
            />
        </Column>
    )
}
